import {FC, useEffect, useState} from 'react'
import s from './user-subscriptions.module.css'
import {Button, Dropdown} from "components/ui";
import {numberToCurrency} from "helpers/currency";
import {ProductQuantity} from "../../../products/components";
import userService from "../../services/user-service";
import {useNotification} from "hooks/use-notification";

const UserSubscriptionsRow: FC<any> = (item: any) => {

  const { notify } = useNotification()

  const [quantity, setQuantity] = useState(0);
  const [price, setPrice] = useState(0);
  const [periodity, setPeriodity] = useState('-');
  const [periodityList, setPeriodityList] = useState<Array<any>>([]);

  const cancel = async () => {
    try {
      let service = new userService();
      let {data} = await service.cancelSubscription(item?.item?.id);
      notify({
        title: 'Sucesso',
        description: 'Assinatura cancelada com sucesso!',
        type: 'success',
      });
      window.location.reload();
    } catch (e) {
      notify({
        title: 'Erro',
        description: 'Erro ao tentar cancelar sua assinatura!',
        type: 'danger',
      })
    }
  }

  const editSubscription = async () => {
    try {
      let service = new userService();
      let data = {
        'quantidade': quantity,
        'periodicidade': periodity,
      }
      await service.editSubscription(item?.item?.id, data);
      notify({
        title: 'Sucesso',
        description: 'Assinatura alterada com sucesso!',
        type: 'success',
      });
    } catch (e) {
      notify({
        title: 'Erro',
        description: 'Erro ao tentar alterar sua assinatura!',
        type: 'danger',
      })
    }
  }

  const onChangeItemQuantity = (next: number) => {
    setQuantity(next)

    let preco = item.item.product.preco;
    let discount = item.item.product.assinatura_desconto_produtor;
    let finalValue = discount > 0 ? preco - (preco*discount/100) : preco;

    setPrice(finalValue * next);
  }

  const choosePeriodity = (selected: any) => {
    setPeriodity(selected);
    // setPrice(item?.item?.product?.preco * quantity);
  }

  useEffect(() => {
    let preco = item.item.product.preco;
    let discount = item.item.product.assinatura_desconto_produtor;
    let finalValue = discount > 0 ? preco - (preco*discount/100) : preco;

    setQuantity(item?.item?.quantidade);
    setPrice(finalValue);
    setPeriodity(item?.item?.periodicidade);
    let p = new Array<any>();
    p.push({value: 'mensal', label: 'Mensal'});
    p.push({value: 'quinzenal', label: 'Quinzenal'});
    p.push({value: 'semanal', label: 'Semanal'});
    setPeriodityList(p);
  }, []);

  return (<div className={s.imgContainer}>
    <div className={s.img}>
      <img width={84} src={item?.item?.product?.images[0]?.nome} alt={'imagem'}/>
    </div>
    <div>
      <b>{item?.item?.product?.nome}</b><br/>
      Preço: R$ {numberToCurrency(price)}<br/>
      Quantidade:
      <ProductQuantity
        canChange={true}
        onChange={({next}) => onChangeItemQuantity(next)}
        quantity={quantity}
        dropdown={false}
      />
      <br/>
      <div className={s.delivery}>
        Entrega:
        <Dropdown dropdownClassName={s.dropdown} selected={periodity} items={periodityList} onSelect={choosePeriodity}  placeholder={'-'}/>
      </div>
      <br/>
    </div>
    <div>
      <Button onClick={() => cancel()} className={'button button-primary mr-2'}>Cancelar assinatura</Button>
    </div>
  </div>)
}

export default UserSubscriptionsRow
